var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38147 3.50732C3.38147 3.23118 3.60533 3.00732 3.88147 3.00732H7.99998H12.1185C12.3946 3.00732 12.6185 3.23118 12.6185 3.50732V5.19211C12.6185 5.46825 12.3946 5.69211 12.1185 5.69211C11.8424 5.69211 11.6185 5.46825 11.6185 5.19211V4.00732H8.49998V11.9927H9.54443C9.82058 11.9927 10.0444 12.2165 10.0444 12.4927C10.0444 12.7688 9.82058 12.9927 9.54443 12.9927H8.01257C8.00839 12.9928 8.00419 12.9928 7.99998 12.9928C7.99577 12.9928 7.99157 12.9928 7.98739 12.9927H6.45555C6.1794 12.9927 5.95555 12.7688 5.95555 12.4927C5.95555 12.2165 6.1794 11.9927 6.45555 11.9927H7.49998V4.00732H4.38147V5.19211C4.38147 5.46825 4.15761 5.69211 3.88147 5.69211C3.60533 5.69211 3.38147 5.46825 3.38147 5.19211V3.50732Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuForm);
export default __webpack_public_path__ + "static/media/a11ymenu_form.f8cbd8bd73fe2e01ea37ab1b8ed9eef9.svg";
export { ForwardRef as ReactComponent };